export function Logo() {
  return (
    <img
      src="https://storage.googleapis.com/norma-dev-general/Norma-logo-with-name.png"
      alt="normaLogo"
      className="md:max-w-[300px] max-w-[200px]"
    />
  );
}
